import React, { Component, useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import DefaultLink from "./DefaultLink";
import MetisMenu from "react-metismenu";
import { unstable_ClassNameGenerator as ClassNameGenerator } from '@mui/material/className';
import { connect } from 'react-redux';
import $ from 'jquery';

// Create a wrapper component to suppress the warning

const MetisMenuWrapper = ({ content, ...props }) => {
  // Disable strict mode for this component
  React.useEffect(() => {
    // This is a workaround to suppress the warning
    ClassNameGenerator.configure((componentName) => componentName);
  }, []);

  // Ensure content is always an array to prevent errors
  const safeContent = Array.isArray(content) ? content : [];

  return (
    <MetisMenu
      content={safeContent}
      {...props}
    />
  );
};



const SideBar = (props) => {
  // Ensure props is always an object
  const safeProps = props || {};
  const location = useLocation();

  const [openDropdown, setOpenDropdown] = React.useState(null); // Start with no dropdown open
  // Lock to keep standalone Active VA dropdown (2063) from auto-opening after navigating via ASM sub-item (id 1090)
  const [lockActiveVAClosed, setLockActiveVAClosed] = React.useState(false);



  const isVendorDashboard = (url) => {

    return url.includes('/vendor/');

  };
  const orgId = sessionStorage.getItem('vendorId');

  const org = JSON.parse(localStorage.getItem('org')) || {};

  React.useEffect(() => {



    const findActiveDropdown = () => {

      let activeDropdown = null;



      // Check if current path matches any submenu item

      if (location.pathname.includes('/asm-details') ||
        location.pathname.includes('/asset') ||
        location.pathname.includes('/known-vulnerabilities') ||
        location.pathname.includes('/active-scan/issue') ||
        (location.pathname.includes('/active-scan') && !location.pathname.includes('/active-scan/schedule')) ||

        location.pathname.includes('/subdomains') ||

        location.pathname.includes('/web-technology') ||

        location.pathname.includes('/spf-dmarc') ||

        location.pathname.includes('/vulnerable-certificates') ||

        location.pathname.includes('/ip-blacklist') ||

        location.pathname.includes('/application-security')) {

        activeDropdown = 1001; // Attack Surface

      } else if (location.pathname.includes('/data-details') ||

        location.pathname.includes('/stolen-credentials') ||

        location.pathname.includes('/malware-credentials') ||

        location.pathname.includes('/leaked-sessions') ||

        location.pathname.includes('/source-code') ||

        location.pathname.includes('/pastebin-search') ||

        location.pathname.includes('/pii') ||

        location.pathname.includes('/telegram-monitoring') ||
        location.pathname.includes('/postman-monitoring') ||

        location.pathname.includes('/cloud-bucket') ||

        location.pathname.includes('/dark-web') ||

        location.pathname.includes('/vip-entities')) {

        activeDropdown = 2002; // Data Exposure

      } else if (location.pathname.includes('/brand-details') ||

        location.pathname.includes('/look-alike') ||

        location.pathname.includes('/mobile-apps') ||

        location.pathname.includes('/social-media') ||

        location.pathname.includes('/brand-mentions') ||
        location.pathname.includes('/seo-poisoning')) {

        activeDropdown = 2001; // Brand Security

      } else if (location.pathname.includes('/blacklist') ||
        location.pathname.includes('/social-media-data') ||
        location.pathname.includes('/blacklist/vendor/') ||
        location.pathname.includes('/social-media-data/vendor/')) {

        activeDropdown = 1020; // Social media Post Monitoring

      } else if (location.pathname.includes('/red-teaming')
        || location.pathname.includes('/red-teaming/dashboard')
        || location.pathname.includes('/red-teaming/simulations')
        || location.pathname.includes('/red-teaming/scans')
        || location.pathname.includes('/red-teaming/issues')
      ) {
        activeDropdown = 102; // Red Teaming

      } else if (location.pathname.includes('/executive-monitoring')
        || location.pathname.includes('/executive-monitoring/vip-members')
        || location.pathname.includes('/executive-monitoring/scans')
        || location.pathname.includes('/executive-monitoring/issues')
      ) {
        activeDropdown = 103; // Executive Monitoring

      } else if (location.pathname.includes('/tprm/') ||

        location.pathname.includes('/vendor/') ||

        location.pathname.includes('/vendor') ||

        location.pathname.includes('/risk-management-dashboard-vendor') ||

        location.pathname.includes('/risk-register-vendor')) {

        activeDropdown = 9009; // TPRM

      } else if (location.pathname.includes('/cve') ||
        location.pathname.includes('/vendor-product') ||
        location.pathname.includes('/cve-monitoring')
      ) {

        activeDropdown = 2050; // CVE Information

      } else if (location.pathname.includes('/threat-intel/')) {

        activeDropdown = 2052; // Threat Intel

      } else if (location.pathname.includes('/forest-view')) {

        activeDropdown = 2062; // Forest View

      } else if (location.pathname.includes('/consolidated-assets') ||
        location.pathname.includes('/scan-logs') ||
        // location.pathname.includes('/active-scan/issue') ||
        location.pathname.includes('/active-scan/schedule') ||
        location.pathname.includes('/cloud-integration')) {
        // Only set Active VA as open if it isn't locked closed by a prior ASM sub-item click
        if (!lockActiveVAClosed) {
          activeDropdown = 2063; // Active VA
        }
      }



      // Avoid overriding Attack Surface (1001) with Active VA (2063) when user came via ASM sub-item
      if (activeDropdown === 2063 && openDropdown === 1001 && lockActiveVAClosed) {
        // Respect lock: keep Attack Surface open
      } else {
        setOpenDropdown(activeDropdown);
      }

    };



    findActiveDropdown();

  }, [location.pathname, openDropdown]);

  // Special case for Postman Monitoring to ensure Data Exposure menu stays open
  React.useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes('/postman-monitoring') && openDropdown !== 2002) {
      // Force Data Exposure dropdown to open when on Postman Monitoring page
      setOpenDropdown(2002);
    }
  }, [location.pathname, openDropdown]);

  // Set initial dropdown state on mount
  React.useEffect(() => {
    if (openDropdown === null) {
      const currentPath = location.pathname;
      let initialDropdown = null;

      if (currentPath.includes('/tprm/') || currentPath.includes('/vendor/') || currentPath.includes('/vendor')) {
        initialDropdown = 9009;
      } else if (currentPath.includes('/asm-details') || currentPath.includes('/asset') || currentPath.includes('/active-scan/issue') || (currentPath.includes('/active-scan') && !currentPath.includes('/active-scan/schedule'))) {
        initialDropdown = 1001;
      } else if (currentPath.includes('/data-details') || currentPath.includes('/stolen-credentials')) {
        initialDropdown = 2002;
      } else if (currentPath.includes('/brand-details') || currentPath.includes('/look-alike')) {
        initialDropdown = 2001;
      } else if (currentPath.includes('/blacklist') || currentPath.includes('/social-media-data') ||
        currentPath.includes('/blacklist/vendor/') || currentPath.includes('/social-media-data/vendor/')) {
        initialDropdown = 1020;
        // Ensure the sidebar stays open
        const body = document.body;
        if (body.classList.contains('left_menu_icon')) {
          body.classList.remove('left_menu_icon');
        }
      } else if (currentPath.includes('/red-teaming')) {
        initialDropdown = 102;
      } else if (currentPath.includes('/executive-monitoring')) {
        initialDropdown = 103;
        // Ensure the sidebar stays open
        const body = document.body;
        if (body.classList.contains('left_menu_icon')) {
          body.classList.remove('left_menu_icon');
        }
      } else if (
        currentPath.includes('/consolidated-assets') ||
        currentPath.includes('/scan-logs') ||
        currentPath.includes('/active-scan/schedule') ||
        currentPath.includes('/cloud-integration')
      ) {
        initialDropdown = 2063;
        setLockActiveVAClosed(false); // Make sure we don't lock the dropdown
      } else if (currentPath.includes('/threat-intel/')) {
        initialDropdown = 2052;
      } else if (currentPath.includes('/cve') || currentPath.includes('/vendor-product') || currentPath.includes('/cve-monitoring')) {
        initialDropdown = 2050;
      }

      if (initialDropdown) {
        setOpenDropdown(initialDropdown);
      }
    }
  }, []);

  // Add event listener to handle clicks on sidebar links
  React.useEffect(() => {
    const handleSidebarClick = (e) => {
      // Check if we clicked on a sidebar link
      const $clickedLink = $(e.target).closest('.metismenu a');
      if ($clickedLink.length) {
        // Remove active class from all other links
        $('.metismenu a').not($clickedLink).removeClass('ACTIVESIDEBAR');
      }
    };

    // Add click listener to the document
    if (typeof $ !== 'undefined' && typeof document !== 'undefined') {
      $(document).on('click', handleSidebarClick);
    }

    // Cleanup
    return () => {
      if (typeof $ !== 'undefined' && typeof document !== 'undefined') {
        $(document).off('click', handleSidebarClick);
      }
    };
  }, []);

  // Force update dropdown state when pathname changes
  React.useEffect(() => {
    const currentPath = location.pathname;
    if (currentPath.includes('/threat-intel/') && openDropdown !== 2052) {
      setOpenDropdown(2052);
    } else if (currentPath.includes('/executive-monitoring') && openDropdown !== 103) {
      setOpenDropdown(103);
      // Ensure the sidebar stays open
      const body = document.body;
      if (body.classList.contains('left_menu_icon')) {
        body.classList.remove('left_menu_icon');
      }
    } else if ((currentPath.includes('/tprm/') || currentPath.includes('/vendor/') || currentPath.includes('/vendor')) && openDropdown !== 9009) {
      setOpenDropdown(9009);
    } else if ((
      currentPath.includes('consolidated-assets') ||
      currentPath.includes('scan-logs') ||
      currentPath.includes('/active-scan/schedule') ||
      currentPath.includes('cloud-integration')
    ) && openDropdown !== 2063) {
      setOpenDropdown(2063);
      setLockActiveVAClosed(false); // Make sure the lock is released
    } else if ((currentPath.includes('/social-media-data') || currentPath.includes('/blacklist') ||
      currentPath.includes('/social-media-data/vendor/') || currentPath.includes('/blacklist/vendor/'))) {
      // Always force Social Media Post Monitoring dropdown to open for these paths, regardless of current state
      setOpenDropdown(1020);
      // Reset any locks that might prevent proper dropdown behavior
      setLockActiveVAClosed(false);
    }
  }, [location.pathname, openDropdown]);

  // Special handling for social-media-data path
  React.useEffect(() => {
    if (location.pathname.includes('/social-media-data') || location.pathname.includes('/blacklist')) {
      // Force open the Social Media Post Monitoring dropdown
      setOpenDropdown(1020);

      // Also use direct DOM manipulation as a fallback
      if (typeof $ !== 'undefined') {
        setTimeout(() => {
          $('.metismenu li').each(function () {
            const $link = $(this).find('> a');
            if ($link.text().includes('Social media Post Monitoring')) {
              const $ul = $(this).find('> ul');
              $ul.addClass('in');
              $link.addClass('ACTIVESIDEBAR');
            }
          });
        }, 100);
      }
    }
  }, [location.pathname]);

  // Clean up classes with jQuery after component updates
  React.useEffect(() => {
    const cleanupClasses = () => {
      if (typeof $ !== 'undefined') {
        // First, remove all 'ACTIVESIDEBAR' classes from all links to ensure only one is active
        $('.metismenu a').removeClass('ACTIVESIDEBAR');

        // Add 'ACTIVESIDEBAR' class to <a> tags inside <li> elements with aria-current="page"
        $('.metismenu li[aria-current="page"] > a').addClass('ACTIVESIDEBAR');

        // Remove all 'in' classes from dropdowns
        $('.metismenu ul').removeClass('in');

        // Remove duplicate collapse classes and ensure proper structure
        $('.metismenu ul').each(function () {
          const $ul = $(this);
          const classes = $ul.attr('class');

          if (classes && classes.includes('collapse')) {
            // Count collapse classes
            const collapseCount = (classes.match(/collapse/g) || []).length;

            if (collapseCount > 1) {
              // Remove all collapse classes and add back just one
              $ul.removeClass('collapse');
              $ul.addClass('collapse');
            }
          }
        });

        if (openDropdown) {
          // Find the dropdown that matches the activeDropdown ID
          $('.metismenu li').each(function () {
            const $li = $(this);
            const $link = $li.find('> a');
            const $ul = $li.find('> ul');

            // Debug: Log all dropdown headers
            if ($link.length > 0 && $ul.length > 0) {
              // Dropdown found
            }

            // Check if this dropdown should be open based on activeDropdown
            let shouldBeOpen = false;

            if (openDropdown === 1001 && $link.text().includes('Attack Surface')) {
              shouldBeOpen = true;
            } else if (openDropdown === 2002 && $link.text().includes('Data Exposure')) {
              shouldBeOpen = true;
            } else if (openDropdown === 2001 && $link.text().includes('Brand Security')) {
              shouldBeOpen = true;
            } else if (openDropdown === 102 && $link.text().includes('Red Teaming')) {
              shouldBeOpen = true;
            } else if (openDropdown === 103 && $link.text().includes('Executive Monitoring')) {
              shouldBeOpen = true;
            } else if (openDropdown === 9009 && $link.text().includes('Vendor Insights')) {
              shouldBeOpen = true;
            } else if (openDropdown === 2050 && $link.text().includes('CVE Information')) {
              shouldBeOpen = true;
            } else if (openDropdown === 2052 && $link.text().includes('Threat Intel')) {
              shouldBeOpen = true;
            } else if (openDropdown === 2062 && $link.text().includes('Forest View')) {
              shouldBeOpen = true;
            } else if (openDropdown === 2063 && $link.text().includes('Active Vulnerability Assessment')) {
              shouldBeOpen = true;
            } else if (openDropdown === 1020 && $link.text().includes('Social media Post Monitoring')) {
              shouldBeOpen = true;
            }

            if (shouldBeOpen && $ul.length > 0) {
              $ul.addClass('in');
              $link.addClass('ACTIVESIDEBAR'); // Add ACTIVESIDEBAR class to the dropdown header
            }
          });
        }
      }
    };

    // Run cleanup after a short delay to ensure DOM is updated
    const timer = setTimeout(cleanupClasses, 100);
    const timer2 = setTimeout(cleanupClasses, 300); // Run again after MetisMenu has processed
    const timer3 = setTimeout(cleanupClasses, 500); // Run one more time to ensure classes are applied
    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
      clearTimeout(timer3);
    };
  }, [openDropdown, location.pathname]);

  // Add an extra effect specifically for handling ACTIVESIDEBAR class on links inside li with aria-current="page"
  React.useEffect(() => {
    const addActiveClassToLinks = () => {
      if (typeof $ !== 'undefined') {
        // First remove all active classes to avoid multiple active items
        $('.metismenu a').removeClass('ACTIVESIDEBAR');
        $('.metismenu li').removeAttr('aria-current');

        // Add 'ACTIVESIDEBAR' class to <a> tags inside <li> elements with aria-current="page"
        $('.metismenu li[aria-current="page"] > a').addClass('ACTIVESIDEBAR');

        // Also try to find active nav links based on current path
        const currentPath = location.pathname;
        $('.metismenu a').each(function () {
          const $link = $(this);
          const href = $link.attr('href');
          if (href && (href === currentPath || currentPath.startsWith(href + '/'))) {
            $link.addClass('ACTIVESIDEBAR');
            $link.parent('li').attr('aria-current', 'page');
          }
        });
      }
    };

    const timer = setTimeout(addActiveClassToLinks, 100);
    const timer2 = setTimeout(addActiveClassToLinks, 500);

    return () => {
      clearTimeout(timer);
      clearTimeout(timer2);
    };
  }, [location.pathname]);

  const toggleSubMenu = (e) => {
    if (e.itemId) {
      // Handle sub-items within a dropdown
      const subClass = e.items.map((menuItem) => {
        // Header items
        if (
          menuItem.id === "main" ||
          menuItem.id === "app" ||
          menuItem.id === "account" ||
          menuItem.id === "extra" ||
          menuItem.id === "ui"
        ) {
          return "header";
        }

        // Check if this menu item has forceOpen property
        if (menuItem.forceOpen) {
          return "collapse in"; // Always keep open if forceOpen is true
        }

        // Accordion behavior: only keep open the dropdown that matches openDropdown state
        if (menuItem.content && menuItem.content.length > 0) {
          if (menuItem.id === openDropdown) {
            return "collapse in"; // Keep this dropdown open - "in" class makes it visible
          } else {
            return "collapse"; // Collapse all other dropdowns
          }
        } else {
          return "collapse"; // Collapse items without content
        }
      });

      return subClass;
    } else {
      // Handle main dropdown items
      if (e.content && e.content.length > 0) {
        // Check if forceOpen is set
        if (e.forceOpen) {
          return "collapse in"; // Always keep open
        }

        // Check if this dropdown contains the active page before allowing close
        const currentPath = location.pathname;

        const isCurrentlyActive = (

          (e.id === 1001 && (

            currentPath.includes('asm-details') ||

            currentPath.includes('assets') ||

            currentPath.includes('known-vulnerabilities') ||
            currentPath.includes('/active-scan/issue') ||
            (currentPath.includes('active-scan') && currentPath.includes('/active-scan/issue') && !currentPath.includes('/active-scan/schedule')) ||

            currentPath.includes('subdomains') ||

            currentPath.includes('web-technology') ||

            currentPath.includes('spf-dmarc') ||

            currentPath.includes('vulnerable-certificates') ||

            currentPath.includes('ip-blacklist') ||

            currentPath.includes('application-security')

          )) ||

          (e.id === 2002 && (

            currentPath.includes('data-details') ||

            currentPath.includes('stolen-credentials') ||

            currentPath.includes('malware-credentials') ||

            currentPath.includes('leaked-sessions') ||

            currentPath.includes('source-code') ||

            currentPath.includes('pastebin-search') ||

            currentPath.includes('pii') ||

            currentPath.includes('telegram-monitoring') ||

            currentPath.includes('postman-monitoring') ||

            currentPath.includes('cloud-bucket') ||

            currentPath.includes('dark-web') ||

            currentPath.includes('vip-entities')

          )) ||

          (e.id === 2001 && (

            currentPath.includes('brand-details') ||

            currentPath.includes('look-alike') ||

            currentPath.includes('mobile-apps') ||

            currentPath.includes('social-media') ||

            currentPath.includes('brand-mentions') ||
            currentPath.includes('seo-poisoning')

          )) ||

          (e.id === 9009 && (

            currentPath.includes('tprm/') ||

            currentPath.includes('vendor/') ||

            currentPath.includes('risk-management-dashboard-vendor') ||

            currentPath.includes('risk-register-vendor')

          )) ||

          (e.id === 2050 && (currentPath.includes('cve') || currentPath.includes('vendor-product') || currentPath.includes('cve-monitoring'))) ||

          (e.id === 2052 && currentPath.includes('threat-intel/')) ||

          (e.id === 102 && currentPath.includes('red-teaming')) ||

          (e.id === 103 && currentPath.includes('executive-monitoring')) ||

          (e.id === 2062 && currentPath.includes('forest-view')) ||

          (e.id === 2063 && (
            currentPath.includes('consolidated-assets') ||
            currentPath.includes('scan-logs') ||
            // currentPath.includes('/active-scan/issue') ||
            currentPath.includes('/active-scan/schedule')
          ))

        );



        if (e.id === openDropdown) {

          if (isCurrentlyActive) {

            return "collapse in"; // Force keep open if contains active page - "in" class makes it open

          } else {

            return "collapse"; // Allow close if no active page

          }

        } else {

          return "collapse"; // Collapse all other dropdowns

        }

      }


      // Handle single menu items

      const currentPath = location.pathname;
      const isActiveRoute = e.to && currentPath.includes(e.to.replace(/^\/+/, ''));

      return isActiveRoute ? "collapse in" : "metismenu";

    }

  };



  let metisMenu = [];


  if ((safeProps.props?.accessLevel !== "Threat Analyst" &&
    safeProps.props?.accessLevel !== "tprm-question-responder" &&
    (safeProps.props?.organisationId?.services?.indexOf("AttackSurface") > -1 ||
      safeProps.props?.organisationId?.services?.indexOf("BrandSecurity") > -1 ||
      safeProps.props?.organisationId?.services?.indexOf("Data Exposure") > -1)) ||
    isVendorDashboard(location.pathname) ||
    safeProps.props?.accessLevel === "mssp") {

    metisMenu.push({

      id: 101,

      icon: "fa fa-chart-line",

      label: "Dashboard",

      to: `/${orgId ? 'dashboard/vendor/' + orgId : ''}`,

    });

  }



  if (

    (props.props.accessLevel === "mssp" && org?.services?.indexOf("AttackSurface") > -1) ||

    props.props.accessLevel === "super-admin" ||

    props.props.accessLevel === "Threat Analyst" ||

    (props.props.accessLevel === "admin" && props?.props?.organisationId?.services.indexOf("AttackSurface") > -1) ||

    (props?.props?.accessLevel === "client" && props?.props?.organisationId?.services.indexOf("AttackSurface") > -1 && ((props?.props?.modulePermissionsConfig?.asm?.e || props?.props?.modulePermissionsConfig?.asm?.r) || isVendorDashboard(location.pathname)))
  ) {

    // Check if ASM module permissions exist and both edit and read are true

    metisMenu.push({
      id: 1001,
      icon: "fa fa-shield-alt",
      label: "Attack Surface",
      to: "/",
      content: [
        {
          id: 7160,
          label: "Summary",
          to: `/asm-details${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 7161,
          label: "IP Discovery & Open Port",
          to: `/asset${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 109,
          label: "Passive Vulnerability Assessment",
          to: `/known-vulnerabilities${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 1090,
          label: "Active Vulnerability Assessment",
          to: `/active-scan/issue${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 7162,
          label: "Subdomain Enumeration",
          to: `/subdomains${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 717,
          label: "Outdated web technologies",
          to: `/web-technology${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 111,
          label: "SPF & DMARC Records",
          to: `/spf-dmarc${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 110,
          label: "Vulnerable SSL Certificates",
          to: `/vulnerable-certificates${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 1180,
          label: "Blacklisted IP",
          to: `/ip-blacklist${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 1181,
          label: "Application Security",
          to: `/application-security${orgId ? '/vendor/' + orgId : ''}`,
        },
        // {
        //   id: 118,
        //   label: "Active-va V2",
        //   to: `/active-vaV2${orgId ? '/vendor/' + orgId : ''}`,
        // }
      ],

    });

  }



  if (

    (props.props.accessLevel === "mssp" && org?.services?.indexOf("Data Exposure") > -1) ||

    props.props.accessLevel === "super-admin" ||

    props.props.accessLevel === "Threat Analyst" ||

    (props.props.accessLevel === "admin" && props?.props?.organisationId?.services.indexOf("Data Exposure") > -1) ||

    (props.props.accessLevel === "client" && props?.props?.organisationId?.services.indexOf("Data Exposure") > -1 &&

      ((props?.props?.modulePermissionsConfig?.de?.e || props?.props?.modulePermissionsConfig?.de?.r) || isVendorDashboard(location.pathname))) ||

    isVendorDashboard(location.pathname)

  ) {

    metisMenu.push({

      id: 2002,

      icon: "fa fa-user-secret",

      label: 'Data Exposure',

      to: "/",

      content: [

        {

          id: 1160,

          label: "Summary",

          to: `/data-details${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 116,

          label: "Stolen Credentials",

          to: `/stolen-credentials${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1161,

          label: "Malware Infected Machines",

          to: `/malware-credentials${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1162,

          label: "Leaked Sessions",

          to: `/leaked-sessions${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 115,

          label: "Source Code Leakage",

          to: `/source-code${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1261,

          label: "Pastebin Search",

          to: `/pastebin-search${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1262,

          label: "Personal Information",

          to: `/pii${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1263,

          label: "Telegram monitoring",

          to: `/telegram-monitoring${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1264,

          label: "Postman Monitoring",

          to: `/postman-monitoring${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 117,

          label: "Open Cloud Buckets",

          to: `/cloud-bucket${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1260,

          label: "Dark web monitoring",

          to: `/dark-web${orgId ? '/vendor/' + orgId : ''}`,

        },

        // {

        //   id: 119,

        //   label: "VIP Monitoring",

        //   to: `/vip-entities${orgId ? '/vendor/' + orgId : ''}`,

        // },

      ],

    });

    // }

  }



  if (

    (props.props.accessLevel === "mssp" && org?.services?.indexOf("BrandSecurity") > -1) ||

    props.props.accessLevel === "super-admin" ||

    props.props.accessLevel === "Threat Analyst" ||

    (props.props.accessLevel === "admin" && props?.props?.organisationId?.services.indexOf("BrandSecurity") > -1) ||

    (props.props.accessLevel === "client" && props?.props?.organisationId?.services.indexOf("BrandSecurity") > -1 &&

      ((props?.props?.modulePermissionsConfig?.bs?.e || props?.props?.modulePermissionsConfig?.bs?.r) || isVendorDashboard(location.pathname))) ||

    isVendorDashboard(location.pathname)

  ) {

    metisMenu.push({

      id: 2001,

      icon: "fa fa-trademark",

      label: "Brand Security",

      to: "/",

      content: [

        {

          id: 11020,

          label: "Summary",

          to: `/brand-details${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 1102,

          label: "Look-alike Domains",

          to: `/look-alike${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 113,

          label: "Rogue Mobile Apps",

          to: `/mobile-apps${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 114,

          label: "Social Media Profiles",

          to: `/social-media${orgId ? '/vendor/' + orgId : ''}`,

        },

        {

          id: 116,

          label: "Brand Mentions",

          to: `/brand-mentions${orgId ? '/vendor/' + orgId : ''}`,

        },
        {
          id: 1163,
          label: "SEO Poisoning",
          to: `/seo-poisoning${orgId ? '/vendor/' + orgId : ''}`,
        }
      ],

    });

    // }

  }

  // Red Teaming Section
  if (
    (props.props.accessLevel === "super-admin" ||
      props.props.accessLevel === "admin" ||
      props.props.accessLevel === "Threat Analyst" ||
      props.props.accessLevel === "mssp") && (org._id == "680a11bbf7f880bc80984cbc" || org._id == "671798d5aba13d551a1384eb" ||
        org._id == "62088cb69f0b0c58a632706a" || org._id == "68c568a15beda0a7182ab932" || org._id == "62088cb69f0b0c58a632706a" ||
        org._id == "67d0242f357c136a2963ef6d" || org._id == "68ba9f624953e4f897dca825" || org._id == "6943a1d8adde84550e3cb6c4" ||
        org._id == "65741905f25d82d21ced1abd" || org._id == "6970929007cd83abc0dfe6e5" || org._id == "698061b81f1ab70ff38d6c35" 
        || org._id == "67f358829b7a7e9beb5ff8a3" || org?.services?.indexOf("RedTeaming") > -1
    )
  ) {
    metisMenu.push({
      id: 102,
      icon: "fa fa-dragon",
      label: "Red Teaming",
      to: "/",
      content: [
        {
          id: 20021,
          label: "Dashboard",
          to: `/red-teaming/dashboard`,
        },
        {
          id: 20022,
          label: "Simulations",
          to: `/red-teaming/simulations`,
        },
        {
          id: 20023,
          label: "Scans",
          to: `/red-teaming/scans`,
        },
        {
          id: 20024,
          label: "Issues",
          to: `/red-teaming/issues`,
        },
      ],
    });
  }

  // Executive Monitoring Section
  if ((
    props.props.accessLevel === "super-admin" ||
    props.props.accessLevel === "admin" ||
    props.props.accessLevel === "Threat Analyst" ||
    org?.services?.indexOf("ExecutiveMonitoring") > -1 ||
    props.props.accessLevel === "mssp") ) {
    metisMenu.push({
      id: 103,
      icon: "fa fa-user-shield",
      label: "Executive Monitoring",
      to: "/",
      content: [
        {
          id: 20031,
          label: "VIP Members",
          to: `/executive-monitoring/vip-members`,
        },
        {
          id: 20032,
          label: "Scans",
          to: `/executive-monitoring/scans`,
        },
        {
          id: 20033,
          label: "Issues",
          to: `/executive-monitoring/issues`,
        },
      ],
    });
  }

  // Social media Post Monitoring
  if (
    (props.props.accessLevel === "super-admin" ||
      props.props.accessLevel === "admin" ||
      props.props.accessLevel === "Threat Analyst" ||
      props.props.accessLevel === "mssp") && (org._id == "68635b04c79355637cec93b7" || org._id == "65741905f25d82d21ced1abd")
  ) {
    metisMenu.push({
      id: 1020,
      icon: "fa fa-share-alt",
      label: "Social media Post Monitoring",
      to: "/",
      forceOpen: true, // Force this dropdown to stay open when its items are visited
      content: [
        {
          id: 200220,
          label: "Configure Blacklist",
          to: `/blacklist`,
        },
        {
          id: 200228,
          label: "Social Media Data",
          to: `/social-media-data`,
          activateParent: 1020 // Ensure this activates Social Media Post Monitoring dropdown
        }
      ],
    });
  }

  if ((org?.services?.indexOf("TPSA") > -1) && (props.props.accessLevel !== "super-admin" || org?.services?.indexOf("TPSA") > -1)
    && props.props.accessLevel !== "tprm-question-responder"
  ) {
    const tprmContent = [];
    tprmContent.push(
      {
        id: 41101,
        label: "Dashboard",
        to: `/tprm/dashboard${orgId ? '/' + orgId : ''}`,
      },
      {
        id: 7104,
        label: "Manage Vendors",
        to: `/tprm/vendor${orgId ? '/vendor/' + orgId : ''}`,
      },
      {
        id: 41101,
        label: "Vendor Tools",
        to: `/vendor${orgId ? '/' + orgId : ''}`,
      }
    );
    // Check for tprm_risk_assessment permissions
    if (!org?.isVendorQuestionairreDisabled) {
      tprmContent.push(
        {
          id: 7100,
          label: "Assessment Campaign",
          to: `/tprm/assessment-campaign${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 7102,
          label: "Manage Questionnaires",
          to: `/tprm/questionnaires${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 7105,
          label: "Trust Panel",
          to: `/tprm/trust-panel${orgId ? '/vendor/' + orgId : ''}`,
        }
      );
    }

    // Add risk register only if either permission exists
    if (!org?.isVendorQuestionairreDisabled) {
      tprmContent.push(
        {
          id: 7103,
          label: "Risk Register",
          to: `/tprm/risk-register${orgId ? '/vendor/' + orgId : ''}`,
        },
        {
          id: 7104,
          label: "AI Helper",
          to: `/tprm/tools${orgId ? '/vendor/' + orgId : ''}`,
        }
      );
    }
    tprmContent.push(
      {
        id: 7103,
        label: "Settings",
        to: `/tprm/settings${orgId ? '/vendor/' + orgId : ''}`,
      }
    );

    // Only add the TPRM menu if there are items to show
    if (tprmContent.length > 0) {
      metisMenu.push({
        id: 9009,
        icon: "fa fa-tasks",
        label: "Vendor Insights",
        to: "/",
        content: tprmContent
      });
    }
  }

  if ((props.props.accessLevel === "tprm-question-responder")) {
    metisMenu.push({
      id: 9009,
      icon: "fa fa-tasks",
      label: "Vendor Insights",
      to: "/",
      content: [
        {
          id: 7100,
          label: "Dashboard",
          to: `/risk-management-dashboard-vendor`,
        },
        {
          id: 7101,
          label: "External Security Risks",
          to: `/tprm/external-security-risks`,
        },
        {
          id: 7900,
          label: "Risk Register",
          to: `/risk-register-vendor`,
        },
        {
          id: 7105,
          label: "Trust Panel",
          to: `/tprm/trust-panel${orgId ? '/vendor/' + orgId : ''}`,
        },
      ],
    });
  }

  if (props.props.accessLevel === "super-admin" || org?.services?.indexOf("Active VA") > -1) {
    metisMenu.push({
      id: 2063,
      icon: "fa fa-crosshairs",
      label: "Active Vulnerability Assessment",
      to: "/",
      activePaths: [
        'consolidated-assets',
        'scan-logs',
        '/active-scan/schedule',
        '/active-scan/issue',
        'cloud-integration'
      ],
      forceOpen: true, // Force this dropdown to stay open
      content: [
        {
          id: 2053,
          label: "Consolidated Assets",
          to: `/consolidated-assets`,
          activateParent: 2063 // This will ensure parent dropdown is activated
        },
        {
          id: 2054,
          label: "Issue Tracker",
          to: `/active-scan/issue`,
          activateParent: 2063
        },
        {
          id: 2055,
          label: "Scan Schedules",
          to: `/active-scan/schedule`,
          activateParent: 2063
        },
        {
          id: 2056,
          label: "Scan Logs",
          to: `/scan-logs`,
          activateParent: 2063
        },
        {
          id: 2057,
          label: "Cloud Integration",
          to: `/cloud-integration`,
          activateParent: 2063
        }
      ],
    });
  }

  // Add Threat Intel section in Main
  if (props.props.accessLevel === "super-admin" || org?.services?.indexOf("ThreatIntelligence") > -1 ||(org._id === "689d805ea2a8b086e848d6c8" || org._id === "671798d5aba13d551a1384eb" || org._id === "68ba9f624953e4f897dca825" || org._id === "62088cb69f0b0c58a632706a" || org._id === "6970929007cd83abc0dfe6e5")) {
    metisMenu.push({
      id: 2052,
      icon: "fa fa-search",
      label: "Threat Intel",
      to: "/",
      content: [
        {
          id: 20521,
          label: "Dashboard",
          to: `/threat-intel/dashboard`,
        },
        {
          id: 2053,
          label: "Search",
          to: `/threat-intel/search`,
        },
        {
          id: 2054,
          label: "Threat Actors",
          to: `/threat-intel/threat-actors`,
        },
        {
          id: 20542,
          label: "Campaigns",
          to: `/threat-intel/campaigns`,
        },
        {
          id: 20541,
          label: "IOC Feeds",
          to: `/threat-intel/feeds`,
        },
        {
          id: 2055,
          label: "Ransomware Tracker",
          to: `/threat-intel/ransomware`,
        },
        {
          id: 20551,
          label: "Hacktivism",
          to: `/threat-intel/hacktivism`,
        },
        {
          id: 2056,
          label: "Threat Intel News Feed",
          to: `/threat-intel/intel-feed`,
        }
      ],
    });
  }

  if (props.props.accessLevel === "admin" || props.props.accessLevel === "super-admin" || props.props.accessLevel === "mssp" || props.props.accessLevel === "client" || props.props.accessLevel === "Threat Analyst") {
        metisMenu.push({
        id: 503,
        icon: "fa fa-exclamation-triangle",
        label: "Risk Centre",
        to: `/consolidated-risks`,
      });

  }


  metisMenu.push({
    id: "manage-section",
    label: "Manage Account",
    icon: "",
    to: "",
    className: "section-header bold"
  });


  if (props.props.accessLevel === "mssp" || props.props.accessLevel === "super-admin" || props.props.accessLevel === "admin" || props.props.accessLevel === "Threat Analyst" || (props.props.accessLevel === "client" && props.props.orgAdmin)) {
    metisMenu.push({
      id: 106,
      icon: "fa fa-user-plus",
      label: "Invite User",
      to: `/invite-user`,
    });
  }

  if (props.props.accessLevel === "super-admin" || org._id === "68ba9f624953e4f897dca825") {
    metisMenu.push({
      id: 107,
      icon: "fa fa-tachometer",
      label: "Manage",
      to: `/manage`,
    });
  }


  if (props.props.accessLevel === "super-admin" || props.props.accessLevel === "Threat Analyst" || (props.props.accessLevel === "client" && props.props.orgAdmin)) {
    if (props.props.accessLevel === "client" && props.props.orgAdmin) {
      metisMenu.push({
        id: 2050,
        icon: "fa fa-shield-virus",
        label: "CVE Information",
        to: "/",
        content: [
          {
            id: 111,
            label: "CVE Monitoring",
            to: `/cve-monitoring`,
          }
        ],
      });

    } else {

      metisMenu.push({
        id: 2050,
        icon: "fa fa-shield-virus",
        label: "CVE Information",
        to: "/",
        content: [
          {
            id: 107,
            label: "CVE Information",
            to: `/cve`,
          },

          {
            id: 111,
            label: "CVE Monitoring",
            to: `/cve-monitoring`,
          },
          {
            id: 110,
            label: "Vendors & Product",
            to: `/vendor-product`,
          },
        ],
      });
    }
  }


  if (props.props.accessLevel !== "Threat Analyst") {
    metisMenu.push({
      id: 501,
      icon: "fa fa-user-circle",
      label: "Profile",
      to: `/profile`,
    });
  }
  if (
    props.props.accessLevel === "super-admin" ||
    props.props.accessLevel === "mssp" || (props.props.accessLevel === "admin" && props.props.organisationId._id === "689d805ea2a8b086e848d6c8")
  ) {
    if (props.props.organisationId._id === "689d805ea2a8b086e848d6c8") {
      metisMenu.push({
        id: 105,
        icon: "fa fa-building",
        label: "Manage Scan",
        to: `/clients`,
      });
    }
    else {
      metisMenu.push({
        id: 105,
        icon: "fa fa-building",
        label: "Clients",
        to: `/clients`,
      });
    }
    if (props.props.accessLevel === "super-admin" || props.props.accessLevel === "Threat Analyst") {
      metisMenu.push({
        id: 1050,
        icon: "fa fa-clock",
        label: "Trial Requests",
        to: `/trial-request`,
      });

      metisMenu.push({
        id: 1051,
        icon: "fa fa-ban",
        label: "Take Down Requests",
        to: `/takedown-request`,
      });

      metisMenu.push({
        id: 1052,
        icon: "fa fa-tools",
        label: "Pending Remediation",
        to: `/pending-remediation`,
      });
    }
  }



  if (props.props.accessLevel === "admin" || props.props.accessLevel === "super-admin" || props.props.accessLevel === "mssp") {
    metisMenu.push({
      id: 502,
      icon: "fa fa-plug",
      label: "Integrations",
      to: `/integrations`,
    });
  }



  return (
    <div>
      <MetisMenuWrapper
        content={metisMenu}
        noBuiltInClassNames={true}
        classNameItemActive="ACTIVESIDEBAR"
        classNameContainer={(e) => toggleSubMenu(e)}
        classNameContainerVisible="in"
        iconNamePrefix=""
        LinkComponent={(e) => <DefaultLink itemProps={e} />}
        onSelected={(e) => {
          // Remove ACTIVESIDEBAR class from all links when clicking on a new one
          if (typeof $ !== 'undefined') {
            $('.metismenu a').removeClass('ACTIVESIDEBAR');
          }

          // If this item has an activateParent property, always open that parent dropdown
          if (e.activateParent) {
            setOpenDropdown(e.activateParent);
            setLockActiveVAClosed(false);
            return;
          }

          // Handle single menu items - automatically open the appropriate dropdown
          if (!e.content || e.content.length === 0) {
            const currentPath = location.pathname;
            let targetDropdown = null;

            // Determine which dropdown should be opened based on the clicked item's route
            if (e.to && (
              e.to.includes('asm-details') ||
              e.to.includes('assets') ||
              e.to.includes('known-vulnerabilities') ||
              e.to.includes('/active-scan/issue') || // map issue tracker to Attack Surface
              (e.to.includes('active-scan') && !e.to.includes('/active-scan/schedule')) ||
              e.to.includes('subdomains') ||
              e.to.includes('web-technology') ||
              e.to.includes('spf-dmarc') ||
              e.to.includes('vulnerable-certificates') ||
              e.to.includes('ip-blacklist') ||
              e.to.includes('application-security')
            )) {
              targetDropdown = 1001; // Attack Surface
            } else if (e.to && (
              e.to.includes('data-details') ||
              e.to.includes('stolen-credentials') ||
              e.to.includes('malware-credentials') ||
              e.to.includes('leaked-sessions') ||
              e.to.includes('source-code') ||
              e.to.includes('pastebin-search') ||
              e.to.includes('pii') ||
              e.to.includes('telegram-monitoring') ||
              e.to.includes('postman-monitoring') ||
              e.to.includes('cloud-bucket') ||
              e.to.includes('dark-web') ||
              e.to.includes('vip-entities')
            )) {
              targetDropdown = 2002; // Data Exposure
            } else if (e.to && (
              e.to.includes('brand-details') ||
              e.to.includes('look-alike') ||
              e.to.includes('mobile-apps') ||
              e.to.includes('social-media') ||
              e.to.includes('brand-mentions')
            )) {
              targetDropdown = 2001; // Brand Security
            } else if (e.to && (
              e.to.includes('blacklist') ||
              e.to.includes('social-media-data')
            )) {
              targetDropdown = 1020; // Social media Post Monitoring
              // Explicitly set the dropdown without any conditions to ensure it opens
              setOpenDropdown(1020);
              // Prevent sidebar from minimizing when clicking on social media data or blacklist
              if (e.to.includes('social-media-data') || e.to.includes('blacklist')) {
                // Ensure the sidebar stays open by preventing any minimize behavior
                const body = document.body;
                if (body.classList.contains('left_menu_icon')) {
                  body.classList.remove('left_menu_icon');
                }
              }
            } else if (e.to && e.to.includes('red-teaming')) {
              targetDropdown = 102; // Red Teaming
            } else if (e.to && e.to.includes('executive-monitoring')) {
              targetDropdown = 103; // Executive Monitoring
              // Prevent sidebar from minimizing when clicking on executive monitoring links
              const body = document.body;
              if (body.classList.contains('left_menu_icon')) {
                body.classList.remove('left_menu_icon');
              }
            } else if (e.to && (
              e.to.includes('tprm/') ||
              e.to.includes('vendor/') ||
              e.to.includes('risk-management-dashboard-vendor') ||
              e.to.includes('risk-register-vendor')
            )) {
              targetDropdown = 9009; // TPRM
            } else if (e.to && (
              e.to.includes('cve') ||
              e.to.includes('vendor-product') ||
              e.to.includes('cve-monitoring')
            )) {
              targetDropdown = 2050; // CVE Information
            } else if (e.to && e.to.includes('threat-intel/')) {
              targetDropdown = 2052; // Threat Intel
            } else if (e.to && e.to.includes('forest-view')) {
              targetDropdown = 2062; // Forest View
            } else if (e.to && (
              e.to.includes('consolidated-assets') ||
              e.to.includes('scan-logs') ||
              e.to.includes('/active-scan/schedule') ||
              e.to.includes('cloud-integration')
            )) {
              targetDropdown = 2063; // Active VA
              // Always release lock for Active VA items when clicked directly
              setLockActiveVAClosed(false);
            }

            // If click originated from ASM's "Active Vulnerability Assessment" sub-item (id 1090)
            // keep Attack Surface (1001) open and suppress auto-open of standalone Active VA (2063)
            if (e.id === 1090) {
              // User clicked ASM -> Active Vulnerability Assessment (sub-item); lock standalone Active VA menu closed
              setLockActiveVAClosed(true);
              targetDropdown = 1001; // Ensure Attack Surface stays open
            }
            if (targetDropdown && targetDropdown !== openDropdown) {
              setOpenDropdown(targetDropdown);
            }
            return;
          }

          // Handle manual dropdown toggle for accordion behavior
          if (e.content && e.content.length > 0) {
            if (openDropdown === e.id) {
              // Check if this dropdown contains the currently active page - SIMPLIFIED VERSION
              const isCurrentlyActive = (() => {
                const currentPath = location.pathname;

                // Check if we're on any Attack Surface page and this is Attack Surface dropdown
                if (e.id === 1001 && (
                  currentPath.includes('asm-details') ||
                  currentPath.includes('assets') ||
                  currentPath.includes('known-vulnerabilities') ||
                  currentPath.includes('/active-scan/issue') ||
                  (currentPath.includes('active-scan') && !currentPath.includes('/active-scan/schedule')) ||
                  currentPath.includes('subdomains') ||
                  currentPath.includes('web-technology') ||
                  currentPath.includes('spf-dmarc') ||
                  currentPath.includes('vulnerable-certificates') ||
                  currentPath.includes('ip-blacklist') ||
                  currentPath.includes('application-security')
                )) {
                  return true;
                }

                // Add more simple checks for other dropdowns
                if (e.id === 2002 && (
                  currentPath.includes('data-details') ||
                  currentPath.includes('stolen-credentials') ||
                  currentPath.includes('malware-credentials') ||
                  currentPath.includes('leaked-sessions') ||
                  currentPath.includes('source-code') ||
                  currentPath.includes('pastebin-search') ||
                  currentPath.includes('pii') ||
                  currentPath.includes('telegram-monitoring') ||
                  currentPath.includes('postman-monitoring') ||
                  currentPath.includes('cloud-bucket') ||
                  currentPath.includes('dark-web') ||
                  currentPath.includes('vip-entities')
                )) {
                  return true;
                }

                if (e.id === 2001 && (
                  currentPath.includes('brand-details') ||
                  currentPath.includes('look-alike') ||
                  currentPath.includes('mobile-apps') ||
                  // Make sure we only match the exact social-media path, not social-media-data
                  (currentPath.includes('social-media') && !currentPath.includes('social-media-data')) ||
                  currentPath.includes('brand-mentions') ||
                  currentPath.includes('seo-poisoning')
                )) {
                  return true;
                }

                if (e.id === 1020 && (
                  currentPath.includes('blacklist') ||
                  currentPath.includes('social-media-data') ||
                  currentPath.includes('/blacklist/vendor/') ||
                  currentPath.includes('/social-media-data/vendor/')
                )) {
                  return true;
                }



                if (e.id === 9009 && (
                  currentPath.includes('tprm/') ||
                  currentPath.includes('vendor/') ||
                  currentPath.includes('risk-management-dashboard-vendor') ||
                  currentPath.includes('risk-register-vendor')
                )) {
                  return true;
                }

                if (e.id === 2050 && (currentPath.includes('cve') || currentPath.includes('vendor-product') || currentPath.includes('cve-monitoring'))) {
                  return true;
                }

                if (e.id === 102 && currentPath.includes('red-teaming')) {
                  return true;
                }

                if (e.id === 103 && currentPath.includes('executive-monitoring')) {
                  return true;
                }

                if (e.id === 2052 && currentPath.includes('threat-intel/')) {
                  return true;
                }

                if (e.id === 2062 && currentPath.includes('forest-view')) {
                  return true;
                }

                if (e.id === 2063 && (
                  currentPath.includes('consolidated-assets') ||
                  currentPath.includes('scan-logs') ||
                  currentPath.includes('/active-scan/schedule') ||
                  currentPath.includes('cloud-integration')
                )) {
                  return true;
                }

                return false;
              })();

              if (isCurrentlyActive) {
                // Don't close if this dropdown contains the current active page
                return;
              } else {
                setOpenDropdown(null); // Close if no active page inside
              }
            } else {
              setOpenDropdown(e.id); // Open this dropdown and automatically close others
              if (e.id === 2063) {
                // User explicitly opened standalone Active VA; release lock
                setLockActiveVAClosed(false);
              }
            }
          }
          // Note: Removed the logic that closes dropdowns when clicking single menu items
          // This allows dropdowns to stay open when navigating to different pages
        }}
      />
    </div>
  );
};

// Connect to Redux to get basic state and ensure store is available
const mapStateToProps = state => ({
  // Add some basic state to ensure connection works
  settings: state.settings || {},
  auth: state.auth || {}
});

export default connect(mapStateToProps)(SideBar);